// userStore — pequeño store compartido para datos de usuario que viven en localStorage
// y filtros contextuales (edad, salas guardadas, notificaciones).
const AGE_KEY = 'user_age';
const NOTIFS_KEY = 'user_notifs';

export function getStoredAge() {
  try { const v = localStorage.getItem(AGE_KEY); return v ? Number(v) : null; } catch (e) { return null; }
}
export function setStoredAge(age) {
  try { localStorage.setItem(AGE_KEY, String(age)); window.dispatchEvent(new Event('clubbers:age-change')); } catch (e) { /* noop */ }
}

export function getNotifs() {
  try { return localStorage.getItem(NOTIFS_KEY) !== '0'; } catch (e) { return true; }
}
export function setNotifs(on) {
  try { localStorage.setItem(NOTIFS_KEY, on ? '1' : '0'); } catch (e) { /* noop */ }
}

export function getFavVenues() {
  try { return JSON.parse(localStorage.getItem('fav_venues') || '[]'); } catch (e) { return []; }
}
